import forEach from 'lodash/forEach';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import _pick from 'lodash/pick';
import _get from 'lodash/get';

import { createSelector } from 'reselect';

import { getDateRangeFromCalendar } from '../../../../shared/calendar';

const defaultInitialState = {
	columns: {
		date: {
			index: 'date'
		}
	},
	groupColumns: {
		date: {
			index: 'date',
			title: 'Date'
		},
		cancellation_reason: {
			index: 'cancellation_reason',
			title: 'Cancellation reason'
		},
		affiliate: {
			index: 'affiliate',
			title: 'Affiliate'
		},
		offer: {
			index: 'offer',
			title: 'Offer'
		},
		geo: {
			index: 'geo',
			title: 'Country'
		},
		status: {
			index: 'status',
			title: 'Status'
		},
		category: {
			index: 'category',
			title: 'Category'
		},
		manager: {
			index: 'manager',
			title: 'Manager'
		},
		campaign: {
			index: 'campaign',
			title: 'Campaign'
		},
		sid1: {
			index: 'sid1',
			title: 'SID 1'
		},
		sid2: {
			index: 'sid2',
			title: 'SID 2'
		},
		sid3: {
			index: 'sid3',
			title: 'SID 3'
		},
		sid4: {
			index: 'sid4',
			title: 'SID 4'
		},
		sid5: {
			index: 'sid5',
			title: 'SID 5'
		}
	},
	sortMain: { index: 'date', direction: 'desc' },
	sortAdditional: null,
	sortInternal: null
};

const createTable = ({
	namespace,
	stateNodeName
}) => {
	// actions types

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {

	};

	// reducers
	const reducers = {

	};

	// selectors
	const getData = state => state.invalid.data;
	const getQuery = state => state.invalid.query;
	const getTable = state => state.invalid.table;
	const getCurrentLang = state => state.root.currentLang;
	const getCalendar = state => state.invalid.calendar;
	const getLists = state => state.root.lists;
	const getGroupCols = state => _get(state, 'invalid.groups.listOfControls');
	const getFilters = state => state.invalid.filters.selectedFilters;

	const selectors = {
		getGroupColumns: state => state.invalid.table.groupColumns,
		getSort: state => _pick(state.invalid.table, ['sortMain', 'sortAdditional', 'sortInternal']),
		getData: createSelector(
			getData,
			getQuery,
			getTable,
			getCurrentLang,
			getCalendar,
			getLists,
			getFilters,
			getGroupCols,
			(data, query, table, currentLang, calendar, lists, filters, groups) => {
				const { groupColumns } = table;
				const rows = data || [];

				let queryFilters = {};
				filters && forEach(filters, f => queryFilters[f.name] = map(f.value, v => v.value));
				query.filters = queryFilters;

				const selectedFilters = [];
				filters && forEach(filters, f => {
					if (!isEmpty(f.value)) {
						selectedFilters.push({name: f.name, values: f.value});
					}
				});
				query.groups = [];

				return {
					rows,
					dataForGoalsQuery: {
						currentQuery: {
							...query,
							date_range: getDateRangeFromCalendar(calendar)
						},
						selectedFilters,
						conversionsStatuses: lists['conversion-statuses'],
						groupColumns: groupColumns
					}
				};
			}
		)
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

// functions

export default createTable;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/table/invalid/index.js